import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            视频分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">探索丰富的视频内容，发现你的观影喜好</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4" id="video-categories">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 hover:bg-primary-500 rounded-xl p-4 md:p-5 text-center transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-500/10 group-hover:bg-white/20 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-500 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-white transition-colors whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 group-hover:text-white/70 transition-colors mt-1 hidden sm:block">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}